// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2y4h7","title":"BackImages_title__EG8qt","images":"BackImages_images__2JEZY"};